
var id = "changeLevel";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"changeLevel\">\n<style type=\"text/css\">\n\t#changeLevel .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#D8D8D8;stroke:#1B60AD;stroke-width:1.5;}\n\t#changeLevel .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#1B60AD;}\n</style>\n<title>等级-icon</title>\n<path id=\"changeLevel_形状结合\" class=\"st0\" d=\"M8,0.8c1.5,0,2.9,0.5,4.1,1.2c1.2,0.8,2.1,2,2.7,3.3l0-0.1l-0.6,0c-0.5-1.1-1.2-1.9-2.1-2.6\n\tl-0.2-0.2C10.7,1.7,9.4,1.2,8,1.2c-1.9,0-3.6,0.8-4.8,2s-2,2.9-2,4.8s0.8,3.6,2,4.8s2.9,2,4.8,2c2.3,0,4.4-1.2,5.6-3l0,0l0.6,0\n\tc-0.6,0.9-1.3,1.7-2.2,2.3c-1.2,0.8-2.5,1.2-4,1.2c-2,0-3.8-0.8-5.1-2.1S0.8,10,0.8,8s0.8-3.8,2.1-5.1S6,0.8,8,0.8z\" />\n<g>\n\t<g transform=\"translate(5.000000, 4.000000)\">\n\t\t<g>\n\t\t\t<path class=\"st1\" d=\"M2.2,1.7h1.2L1.7,0L0,1.7h1.2v4.9H0l1.7,1.7l1.7-1.7H2.2V1.7z M4,1v1h5.9V1H4z M4,8h5.9V7H4V8z M4,5h7V4H4V5\n\t\t\t\tz\" />\n\t\t</g>\n\t</g>\n</g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
